
import { createVNode, defineComponent } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { getObjList } from '@/utils/function';

export default defineComponent({
  name: 'Cell_technicsinfolist',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: false,
    },
    record: {
      type: Object,
      required: false,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
    handleOpenEdit: {
      type: Function,
      required: true,
    },
    handleDelete: {
      type: Function,
      required: true,
    },
  },
  setup(props: any) {
    const ask_do = (t_obj: any) => {
      Modal.confirm({
        title: () => '是否操作这个记录?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: '操作',
        onOk() {
          Modal.confirm({
            title: () => '请选择您的操作类型?',
            icon: () => createVNode(ExclamationCircleOutlined),
            okText: '修改',
            cancelText: '删除',
            cancelButtonProps: { danger: true },
            onOk() {
              props.handleOpenEdit(t_obj);
            },
            onCancel() {
              props.handleDelete(t_obj);
            },
          });
        },
        onCancel() {},
      });
    };

    const obj: any = props.record[props.column.field];
    return {
      obj: obj,
      ask_do,
    };
  },
});
